import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function updateRunName(runId, newName) {
    /**
     * This function sends a POST request to the backend server to update the name of a run.
     * It takes in the runId and newName and returns the response from the server.
     * 
     * @param {string} runId - The ID of the run to update.
     * @param {string} newName - The new name for the run.
     * @returns {Object} - The response from the server.
     */
    if (!runId) {
        throw new Error('Run ID is required for updateRunName')
    }
    if (!newName) {
        throw new Error('New name is required for updateRunName')
    }
    // Check if the run ID is a string
    if (typeof runId !== 'string') {
        throw new Error('Run ID must be a string')
    }
    // Check if the new name is a string
    if (typeof newName !== 'string') {
        throw new Error('New name must be a string')
    }
    
    /* `run_name`, not `new_name`: the backend's UpdateRunRequest is
       {run_id, run_name} with no alias, so `new_name` was a 422 on every call
       and no run could be renamed. (app/schemas/history.py.) */
    const requestJson = {
        "run_id": runId,
        "run_name": newName
    }
    const retJson = await generic_backend_request_post(requestJson, '/update_run_name');
    return retJson;

}

export default updateRunName